import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema4/GLB_T4_Escaner.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Escaner extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.241, -0.992, -2.78);
		this.scale.set(4.292, 4, 4.960);
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Escaner = gltf.scene.getObjectByName("Escaner", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Escaner");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	onAnimateScaner() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.Escaner
		this.Escaner.material.emissive.set("#404040");

		this.animation = gsap.to(this.Escaner.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
}